<mat-form-field class="example-full-width" [ngClass]="field.ocr_confidence_level_cssclass">
    <mat-label for="{field.field_name}">{{field.field_name}}
        <span *ngIf="field.is_mandatory == 1" class="field-mandatory">*</span>
    </mat-label>
    <input type="text" [id]="field.field_name" #InputAutoComplete matInput [formControl]="myControl"
        [matAutocomplete]="auto" (input)="onSelectionChange($event)" (focus)="ocrFocus(field)"
        (keypress)="omit_special_char($event,field.valid_input_regexp);">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
        (optionSelected)='onOptionSelected($event.option.value)'>
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option" matTooltip="{{option.name}}">
            {{option.name}}
        </mat-option>
    </mat-autocomplete>
    <button *ngIf="field.is_magnify_search==1" mat-button matSuffix mat-icon-button
        [disabled]="field.is_readonly == 1 || field.is_editable == 0"
        (click)="$event.stopPropagation();openAdvanceSearchModal(field.field_mapping_detail_id)">
        <mat-icon>search</mat-icon>
    </button>
    <mat-error *ngIf="f.errors?.required">
        {{field.field_name}} is required.
    </mat-error>
</mat-form-field>